import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-hellosign',
  templateUrl: './hellosign.component.html',
  styleUrls: ['./hellosign.component.scss']
})
export class HellosignComponent implements OnInit {

  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['hellosign'];
  }

}
